module.exports = __webpack_public_path__ + "U-wHIkQ_AgupXdkBT/RDC_RED_Logo_House.svg";